export function ManagerAppBaseRoutes(
    $stateProvider,
    $locationProvider,
    $urlMatcherFactoryProvider,
    $compileProvider,
    $urlRouterProvider,
    $logProvider,
    BASE_PATH,
    PAGE_LAYOUT,
    LOG_LEVELS,
    DebugSettingsProvider,
    IS_PRODUCTION
) {
    $logProvider.debugEnabled(!IS_PRODUCTION);

    // When debugging is enabled, scope references will be attached to the DOM elements
    $compileProvider.debugInfoEnabled(DebugSettingsProvider.settings.LOG_LEVEL === LOG_LEVELS.VERBOSE);

    $locationProvider.html5Mode(true);
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    // default not found page
    function otherwise($injector) {
        $injector.get('$state').go('404');
    }
    otherwise.$inject = ['$injector'];
    $urlRouterProvider.otherwise(otherwise);

    $stateProvider
        .state('404', {
            template: require('./error-views/404.html'),
            params: {
                errorMessage: null  
            },
            controller: 'NotFoundPageController as vm',
            resolve: {
                logErrorMessage: ['$stateParams', function logErrorMessage($stateParams) {
                    if ($stateParams.errorMessage) {
                        console.error($stateParams.errorMessage);
                    }
                    return true;
                }]
            }
        })
        .state('noaccess', {
            template: require('./error-views/no-access.html'),
            controllerAs: 'vm',
            controller: function controller() {
                this.link = BASE_PATH;
            }
        })
        .state('500', {
            template: require('./error-views/500.html'),
            controllerAs: 'vm',
            controller: function controller() {
                this.link = BASE_PATH;
            }
        });
}

ManagerAppBaseRoutes.$inject = [
    '$stateProvider',
    '$locationProvider',
    '$urlMatcherFactoryProvider',
    '$compileProvider',
    '$urlRouterProvider',
    '$logProvider',
    'BASE_PATH',
    'PAGE_LAYOUT',
    'LOG_LEVELS',
    'DebugSettingsProvider',
    'IS_PRODUCTION'
];
